import { useMemo } from 'react';
import type { CSSProperties, JSX, ReactNode } from 'react';
import { Typography } from 'antd';

import { isRichTextEmpty, sanitizeRichTextHtml } from '@tools/utils/richTextHtml.ts';

const { Text } = Typography;

interface RichTextDisplayProps {
  value?: string | null;
  emptyText?: ReactNode;
  className?: string;
  style?: CSSProperties;
}

const baseStyle: CSSProperties = {
  overflowWrap: 'anywhere',
  whiteSpace: 'pre-wrap',
};

export function RichTextDisplay({
  value,
  emptyText = 'Sin nota registrada',
  className,
  style,
}: RichTextDisplayProps): JSX.Element {
  const safeHtml = useMemo(() => sanitizeRichTextHtml(value), [value]);

  if (isRichTextEmpty(value)) {
    return (
      <Text type="secondary" italic>
        {emptyText}
      </Text>
    );
  }

  return (
    <div
      className={className}
      style={{ ...baseStyle, ...style }}
      dangerouslySetInnerHTML={{ __html: safeHtml }}
    />
  );
}

export default RichTextDisplay;
